import {
  object,
  string,
} from 'yup';
import {
  MY_FORM_FIELD_TEXT,
  MY_FORM_FIELD_DATE,
  MY_FORM_FIELD_IMAGE,
} from '../../../form/form-constants';

const nameTitle = 'title';
const namePublishedAt = 'publishedAt';
const namePicture = 'picture';

export const sampleCrudFields = [
  {
    type: MY_FORM_FIELD_TEXT,
    name: nameTitle,
    labelId: 'news.form.title',
    inputProps: {
      autoFocus: true,
    },
  },
  {
    type: MY_FORM_FIELD_DATE,
    name: namePublishedAt,
    labelId: 'news.form.publishedAt',
    inputProps: {
    },
  },
  {
    type: MY_FORM_FIELD_IMAGE,
    name: namePicture,
    labelId: 'news.form.picture',
    inputProps: {
    },
  },
];

export const sampleCrudValidationSchema = object({
  [nameTitle]: string('')
    .trim()
    .required('news.form.title.required'),
  [namePublishedAt]: string('')
    .nullable()
    .required('news.form.publishedAt.required'),
  [namePicture]: string('')
    .required('news.form.picture.required'),
});
